import VersionService from "../../../shared/services/VersionService";
import { db } from "../../../shared/plugins/firebase-app";

const versionService = new VersionService(db);
export default versionService;
